import axios from 'axios'
import {asNumber, asResponse, qs} from '../util'
import {mutate} from 'swr'
import {orderBy} from 'lodash'


export const RESOURCE_SWR_KEY = ({resourceId, tab = 'responses'}) => [
  '/bff/resources/${resourceId}',
  resourceId,
  tab
]

export const getResource = async (url, resourceId, tab = 'responses') => {
  if (!resourceId) {
    return {
      resource: undefined
    }
  }
  const loadArg = tab === 'responses' ? '?load=responses[{"projection": {"body": 0}}]' : '?load=logs[{"options":{"skip": 0, "limit":100, "sort": {"createdAt":-1}}}]'
  const resp = await asResponse(axios.get(url.replace('${resourceId}', resourceId) + loadArg))
  resp.data.responses = orderBy(resp.data.responses, ['weight', 'status'], ['desc', 'asc'])
  return {
    resource: resp.data
  }
}

export const mutateResource = async function () {
  let args = Array.from(arguments)
  const resourceId = args[args.length - 2]
  const tab = args[args.length - 1]
  const key = RESOURCE_SWR_KEY({resourceId, tab})
  args = [key, ...args]
  return mutate.apply(this, args)
}

export const upsertResource = async (resource) => {
  const verb = resource.id ? 'put' : 'post'
  const path = resource.id ? `/bff/resources/${resource.id}` : `/bff/resources`
  const resp = await asResponse(axios[verb](path, {...resource, ...{weight: asNumber(resource.weight)}}))
  return resp.data
}

export const removeResource = async (resourceId, skipConflictCheck) => {
  return axios.delete(`/bff/resources/${resourceId}${qs({skipConflictCheck})}`)
}

export const cloneResource = async (resourceId) => {
  const resp = await asResponse(axios.post(`/bff/resources/clone`, {id: resourceId}))
  return resp.data
}

export const copyResourceTo = async (resourceId, serviceId, versionId, environmentId) => {
  const resp = await asResponse(axios.post(`/bff/resources/copy-to`, {
    id: resourceId,
    serviceId,
    versionId,
    environmentId
  }))
  return resp.data
}


